<template>
  <div class="background-wrapper-other">
    <div class="breadcrumb">
      <div class="container">
        <ul>
          <li><router-link to="/">HARUMIFLAG</router-link></li>
          <li><router-link to="/event">イベント一覧</router-link></li>
        </ul>
      </div>
    </div>
    <div class="event">
      <div class="container">
        <div class="event__title">
          <h2>EVENT<span>イベント一覧</span></h2>
        </div>
        <div class="event__filter">
          <div class="event__filter__item">
            <div class="item__holder">
              <button data-tab="filtercalender" class="btn">
                カレンダーから探す
              </button>
            </div>
          </div>
          <div class="event__filter__item">
            <div class="item__holder">
              <button data-tab="filtercategoty" class="btn">
                ジャンルから探す
              </button>
            </div>
          </div>
        </div>

        <div class="event__btn">
          <div class="event__btn__1">
            <router-link to="" class="btn active">新着順</router-link>
          </div>
          <div class="event__btn__2">
            <router-link :to="'/event/event_start_date/genre/' + genreName" class="btn">開催日順</router-link>
          </div>
        </div>
        <div class="event__filter__content">
          <div id="filtercategoty" class="filtercategoty tab-content">
            <ul class="category__list">
              <li class="category__list__item" :class="genreName === genre ? 'active' : ''" v-for="(genre, index) in genreList" :key="index">
                <router-link :to="'/event/genre/' + genre">{{ genre }}</router-link>
              </li>
            </ul>
            <!-- <div class="category__btn">
              <router-link to="#" class="btn">検索</router-link>
            </div> -->
          </div>
          <div id="filtercalender" class="filtercalender tab-content">
            <div class="filtercalender__child">
              <vc-date-picker 
                v-model="datePicker" 
                locale="ja" 
                :lang="lang"
                :masks="{ title: 'YYYY/MM' }"
                @dayclick="onDayClick"
                :attributes="attributes"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="event__list">
        <div class="container">
          <div class="container-child">
            <div class="cont">
              <EventListGenre />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import CONSTANT from "@/constant";
import { metaData } from '@/utils/helper';

export default {
  name: "EventGenre",
  components: {
    EventListGenre: () => import("@/components/common/event/EventListGenre.vue"),
  },
  data() {
    return {
      datePicker: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10),
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      genreList: CONSTANT.dataGenre,
      genreName: this.$route.params.id,
      attributes: []
    };
  },
  methods: {
    onDayClick(day) {
        const params_date = moment(day.date).format("YYYYMMDD");
        if (this.$route.name !== params_date) {
          this.$router.push({ path: '/event/date/'+ params_date }).catch(()=>{});
        }
    },
  },
  computed: {},
  created() {
    metaData(
      `イベント情報 | HARUMIFLAGタウンポータル`,
      '中央区晴海・HARUMIFLAGのイベント一覧。おすすめのイベントをお知らせします。',
      'HARUMIFLAGタウンポータル',
      'blog',
    )
    this.attributes = [
      {
        highlight: {
          class: 'day-selected'
        },
        dates: new Date(),
      }
    ]
  }
};
</script>